import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { getBookingOrderPrefill } from '../../../services/requests/bookings/bookings-requests';
import { applyConsigneeDefaults } from './bookings-consignee';

// Legacy Bookings_Add LoadOrderInfo: ?OrderID=<order id> pre-fills the new booking from the order.
export const BookingOrderPrefill = ({ setValue }: any) => {
  const [searchParams] = useSearchParams();
  const orderKey = Array.from(searchParams.keys()).find((k) => k.toLowerCase() === 'orderid');
  const orderId = orderKey ? searchParams.get(orderKey) : null;

  useEffect(() => {
    const id = parseInt(orderId ?? '', 10);
    if (Number.isNaN(id)) return;
    getBookingOrderPrefill(id)
      .then((p) => {
        if (!p) return;
        const set = (name: string, value: any) => {
          if (value !== null && value !== undefined) setValue(name, value);
        };
        set('customerId', p.customerId);
        set('containerId', p.containerId);
        set('plantId', p.plantId);
        set('poNumber', p.poNumber);
        set('lindeOrderId', p.lindeOrderId);
        set('dateRequested', p.dateRequested);
        set('dateOrderReceived', p.dateOrderReceived);
        set('orderId', p.orderId);
        applyConsigneeDefaults(p.consignee, setValue);
      })
      .catch(() => toast.error('Unable to load the order.'));
  }, [orderId]);

  return null;
};
